/* @ts-ignore */
import quick_decision_img from "@images/projects/quick_decision.png";
/* @ts-ignore */
import brighter_time from "@images/projects/brighter_time.png";
/* @ts-ignore */
import dash_img from "@images/projects/dash.png";
/* @ts-ignore */
import meteor_shift_img from "@images/projects/meteor_shift.png";
/* @ts-ignore */
import extension_img from "@images/projects/extension.png";
/* @ts-ignore */
import hand_drawing_img from "@images/projects/hand_drawing.png";
/* @ts-ignore */
import dash_man_img from '@images/projects/dash_man.png';

export const PROJECTS = [
  {
    name: "Hand Drawing",
    links: {
      official: "https://hand-drawing.herokuapp.com/",
      github: "https://github.com/lijason103/HandDrawing",
    },
    description: "A web app that converts an image into a sketch drawing and animates the drawing strokes on the canvas.",
    tags: ["React", "JavaScript", "OpenCV", "Flask"],
    img: hand_drawing_img,
  },
  {
    name: "DashMan",
    links: {
      official: "https://dashman.herokuapp.com/",
      github: "https://github.com/lijason103/DashMan",
    },
    description: `A multiplayer web game where players compete to be the last one standing by "dashing" toward other players. Players can "dash" by long-pressing the arrow keys with limited energy. There are also obtainable buffs on the map.`,
    tags: ["PixiJS", "SocketIO", "JavaScript", "React"],
    img: dash_man_img,
  },
  {
    name: "Quick Decision",
    links: {
      googleapp: "https://play.google.com/store/apps/details?id=com.spintoeat",
    },
    description:
      "An Android app that helps users make a decision quickly by using a spinning wheel. It allows users to customize and save an endless number of decision categories. Simply create a category, fill it with choices and spin!",
    tags: ["Android", "React Native", "Redux", "Illustrator"],
    img: quick_decision_img,
  },
  {
    name: "Twitch Google Assistant",
    links: {
      github: "https://github.com/lijason103/Twitch-Google-Assistant",
    },
    description: "A Google assistant chatbot for Twitch. Viewers can interact with Google assistant through chat via command text.",
    tags: ["Google Assistant", "Twitch", "JavaScript"],
  },
  {
    name: "Meteor Shift",
    links: {
      googleapp:
        "https://play.google.com/store/apps/details?id=com.jli.game&hl=en",
    },
    description:
      "An Android game app that allows the players to dodge falling meteors using simple controls to achieve the highest score. Players can select from a list of unique skins. Dodge as many as you can! Reach maximum speed and challenge your high score!",
    tags: ["Android", "Java", "Libgdx", "Illustrator"],
    img: meteor_shift_img,
  },
  /**
   * HACKATHONS
   */
  {
    name: "Dash - Hackathon",
    links: {
      github: "https://github.com/lijason103/SystemsHacks2019",
    },
    description:
      "A retro multiplayer web game app where players try to eliminate each other in a constrained game space. The player can move by clicking on a block that is either horizontal or vertical from the player. A player can eliminate others by dashing through them. In addition, the movement is restricted by energy.",
    tags: ["NodeJS", "PhaserJS", "Socket.IO"],
    img: dash_img,
  },
  {
    name: "BrighterTime - Hackathon",
    links: {
      github: "https://github.com/lijason103/BrighterTime",
    },
    description:
      "An iOS app to provide support for people at risk of depression. It allows users to share thoughts anonymously, play games and answer series of real-life situation questions. The inputs from the users were then used to analyze their risk of depression using Machine Learning.",
    tags: ["iOS", "React Native", "Redux", "Flask", "SQL", "Algolia"],
    img: brighter_time,
  },
  {
    name: "EduMatch - Hackathon",
    links: {
      github: "https://github.com/lijason103/edumatch",
    },
    description:
      "A prototype designed using Adobe XD that aims to connect students and mentors from different fields and similar interests together efficiently. Each user has a profile to showcase their skills, talents and interests.",
    tags: ["React Native", "Adobe XD"],
  },
];
